<section>
    <climb-logo [sign]="false"></climb-logo>
    <ng-content></ng-content>
</section>

<ng-content select="[authContainerFooter]"></ng-content>
